import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";

export interface CounterState {
  step: number;
}

const initialState: CounterState = {
  step: 0,
};

export const stepSlice = createSlice({
  name: "step",
  initialState,
  reducers: {
    goToDesign: (state) => {
      state.step = 0;
    },
    goToQuantity: (state) => {
      state.step = 1;
    },
    goToReview: (state) => {
      state.step = 2;
    },
    nextStep: (state) => {
         // Only increment if step is less than 3.
        if (state.step < 3) {
          state.step += 1;
        }
    },    
  },
});

export const { goToDesign, goToQuantity, goToReview, nextStep } =
  stepSlice.actions;

export const selectStep = (state: RootState) => state.steps.step;

export default stepSlice.reducer;
